import { estimationMethod, type } from '@/__generated__/requests'

import { sanitizeEnum } from '@/helpers/sanitizeEnum.helper'

export const MANUAL_ACCOUNT_OPTIONS = Object.values(type).map(value => ({
  label: sanitizeEnum(value),
  value,
}))

export const ESTIMATION_METHOD_OPTIONS = Object.values(estimationMethod).map(
  value => ({
    label: sanitizeEnum(value),
    value,
  }),
)
